import i18n from '../../../i18n';

export type AddStockPillProps = {
  class?: string;
  onclick?: () => void;
};

const PlusIcon = () => (
  <svg class="sti-add-stock-btn-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path d="M7 2V12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M2 7H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

/** 与自选页「添加自选」一致：左侧加号 + 文案（同色） */
export const AddStockPill = (props: AddStockPillProps) => (
  <div
    class={`sti-add-stock-btn${props.class ? ` ${props.class}` : ''}`.trim()}
    onclick={props.onclick}
    role="button"
    tabindex={0}
  >
    <PlusIcon />
    <span class="sti-add-stock-btn-label">{i18n.StockTransferIn.AddStockButton}</span>
  </div>
);
